import { Col, Form, Row } from 'react-bootstrap';
import React, { useEffect, useMemo, useState } from 'react';

import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Text from '@amzn/meridian/text';
import _ from 'lodash';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';

/*
 * Free text attribute. Both name and value are editable.
 */
const TextAttribute = ({ id, onChange, onRemoveAttribute, disabled = false, initialName = '', initialValue = '' }) => {
  const [attributeName, setAttributeName] = useState('');
  const [attributeValue, setAttributeValue] = useState('');

  useEffect(() => {
    setAttributeName(initialName);
  }, [initialName]);

  useEffect(() => {
    setAttributeValue(initialValue);
  }, [initialValue]);

  const removeThisElement = () => {
    onRemoveAttribute(id);
  };

  const updateAttributeName = e => {
    const newName = e.target.value;
    setAttributeName(newName);
    debounceOnChangeName(newName);
  };

  const debounceOnChangeName = useMemo(() => {
    return _.debounce(value => onChange(id, value, attributeValue), 300);
  }, [onChange, id, attributeValue]);

  const updateAttributeValue = e => {
    const newValue = e.target.value;
    setAttributeValue(newValue);
    debounceOnChangeValue(newValue);
  };

  const debounceOnChangeValue = useMemo(() => {
    return _.debounce(value => onChange(id, attributeName, value), 300);
  }, [onChange, id, attributeName]);

  return (
    <Row className="m-1">
      <Col className="col-10">
        <Row>
          <Form.Group as={Col} className="col-6">
            <Text type="b200" tag="label" color="primary" htmlFor={`name-input-${id}`}>
              Attribute name
            </Text>
            <Form.Control
              id={`name-input-${id}`}
              value={attributeName}
              onChange={updateAttributeName}
              disabled={disabled}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-6">
            <Text type="b200" tag="label" color="primary" htmlFor={`value-input-${id}`}>
              Attribute value
            </Text>
            <Form.Control
              id={`value-input-${id}`}
              value={attributeValue}
              onChange={updateAttributeValue}
              disabled={disabled}
            />
          </Form.Group>
        </Row>
      </Col>
      <Col className="col-2 d-flex justify-content-center">
        <Button
          type="tertiary"
          className="mb-3 align-self-end mr-1"
          onClick={() => removeThisElement()}
          disabled={disabled}
        >
          <Icon tokens={trashTokens}></Icon>
        </Button>
      </Col>
    </Row>
  );
};

export default TextAttribute;
